import { API_TYPES, post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS, APP_V2_USER_EVENTS, useToast } from "@src/appV2/lib";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const EMAIL_JOB_SEARCH_AGREEMENT_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/emailJobSearchAgreement`;

const emailJobSearchAgreementResponseSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.jobSearchAgreementEmail),
    id: z.string(),
    attributes: z.object({
      sentTo: z.string(),
      agreementVersion: z.string(),
    }),
  }),
});

interface SendJobSearchAgreementEmailParams {
  agreementVersion: string;
}

export function useSendJobSearchAgreementEmail(
  options: UseMutationOptions<unknown, AxiosError, SendJobSearchAgreementEmailParams> = {}
) {
  const { showErrorToast } = useToast();

  return useMutation({
    mutationFn: async ({ agreementVersion }: SendJobSearchAgreementEmailParams) => {
      await post({
        url: EMAIL_JOB_SEARCH_AGREEMENT_URL,
        data: {
          data: {
            type: API_TYPES.jobSearchAgreementEmail,
            attributes: {
              agreementVersion,
            },
          },
        },
        responseSchema: emailJobSearchAgreementResponseSchema,
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.SEND_JOB_SEARCH_AGREEMENT_EMAIL_FAILURE,
      logSuccessMessage: APP_V2_USER_EVENTS.SEND_JOB_SEARCH_AGREEMENT_EMAIL_SUCCESS,
    },
    onError: () => {
      showErrorToast("There was an error sending the agreement");
    },
    ...options,
  });
}
